import React from "react";
import moment from "moment";
import { WeekColor, convertHoursFormat } from "../../../_helper/helper";

const thStyle = {
  border: "1px solid #e1e1e1",
};
const CommonDataTableTimesheet = (props) => {
  const  TimeFormatConverter = ( time) => { 
    const [hours, minutes] = time.split(':').map(Number); 
    const totalHours = hours + minutes / 60; 
    const formattedTime = totalHours.toFixed(2);
    return `${formattedTime} Hrs`
  }
  const hoursFormat = (hours, type) => {
    return type == "HH:MM" ? hours : `${convertHoursFormat(hours)} hrs`
  }
  const { columns, data, payPeriod, showSR } = props;
  return (
    <div>
      <table
        className="table payroll-content paroll-contents-tables  "
        style={{ width: "100%",padding:"50px" }}
      >
        <thead className="paroll-contents-theads ">
          <tr style={{ border: "1px solid #e1e1e1" }}>
            {/* <th className="paroll-contents-th">
          <p className="tabletitle labelColor">Employee Name</p>
        </th> */}
            {showSR ? (
              <th className="paroll-contents-ths " style={thStyle}>
                <p className="tabletitles labelColor1x" style={{textAlign:"center"}}>#</p>
              </th>
            ) : null}
            {columns?.filter(col => col.isShow != false).map((i) => {
              return (
                <th className="paroll-contents-thx " style={thStyle}>
                  <p className="tabletitlex labelColor1x" style={{textAlign:`${i.align ? i.align : "center"}`}}>{i.label}</p>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody
          className="bg-white  paroll-contents-tbodys"
          style={{ width: "100%" }}
        >
          {data?.map((i, index) => {
            const weekColors = WeekColor(
              payPeriod?.StartDate,
              payPeriod?.EndDate,
              i.date,
              i.jobtype
            );
            // return columns?.map((i, index) => {
            return (
              <tr
                //   key={index}
                //   bordercolor="red"
                //  className={index % 2 === 0 ? "trRow1" : "trRow2"}
                style={{
                  marginBottom: 0,
                  marginTop: 0,
                  padding:0,
                  
                  // backgroundColor: getDateColor(date, rowsData),
                  // alignItems: "center",
                  // display: "flex",
                }}
              >
                {showSR ? (
                  <td
                    className="paroll-contents-tds"
                    style={{ backgroundColor: `${weekColors}` , margin:'1px',textAlign:"center"}}
                  >
                    {index + 1}
                  </td>
                ) : null}
                {columns.filter(col => col.isShow != false).map((col) => {
                  return (
                    <td
                      className="paroll-contents-tds text-left"
                      style={{ backgroundColor: `${weekColors}` , textAlign:`${col.align ? col.align : "center"}`,margin:0}}
                    >
                      {col.type == "hrs" ? hoursFormat(i[col.columnName], col.format) : col.type == "date" ? moment(i[col.columnName]).format(col.format) : col.type == "time" ? i[col.columnName] ? moment(i[col.columnName],"HH:mm").format(col.format) : '-' : col.type == "amount" ? <span style={{display:"flex", justifyContent:"space-between"}}><span>$</span><span>{i[col.columnName] ? parseFloat(i[col.columnName]).toFixed(2) : 0}</span></span> : i[col.columnName]}                      
                    </td>
                  );
                })}
              </tr>
            );
            // });
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CommonDataTableTimesheet;
